import React, { Component } from 'react';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import { Collapse, Button } from 'reactstrap';
import Modal from 'react-bootstrap4-modal';
import { toast } from 'react-toastify';
import { withRouter } from 'react-router-dom';

import QuestionsLists from 'components/questions/modify/QuestionsLists';
import RearrangeQuestions from 'components/questions/modify/RearrangeQuestions';
import CustomSurveyQuestionApi from 'apis/questions/CustomSurveyQuestion';
import Toaster from 'components/Toaster';
import DeleteQuestionModal from 'components/questions/modals/deleteQuestion';
import ActionButtons from './actionButtons';
import AddNewQuestion from './addNewQuestion';

class CustomSurveyQuestions extends Component {
  constructor(props) {
    super(props);
    this.state = {
      addQuestionVisible: false,
      question: '',
      answer: '',
      answers_attributes: [],
      answerError: '',
      questions: [],
      editId: '',
      editAnswerObject: {},
      editAnswerText: '',
      editAnswerIndex: '',
      modalToggle: false,
      questionId: '',
      questionError: '',
      rearrangeMode: false,
      suggestedQuestions: [],
      toggleSuggestions: false,
      survey_template_question_id: null,
    };
    this.addQuestion = this.addQuestion.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.addAnswer = this.addAnswer.bind(this);
    this.toggleAddfalse = this.toggleAddfalse.bind(this);
    this.toggleAddtrue = this.toggleAddtrue.bind(this);
    this.deleteAnswer = this.deleteAnswer.bind(this);
    this.editQuestion = this.editQuestion.bind(this);
    this.deleteQuestion = this.deleteQuestion.bind(this);
    this.confirmDeleteQuestion = this.confirmDeleteQuestion.bind(this);
    this.cancelQuestionDelete = this.cancelQuestionDelete.bind(this);
    this.confirmEdit = this.confirmEdit.bind(this);
    this.cancelEdit = this.cancelEdit.bind(this);
    this.handleKeyPress = this.handleKeyPress.bind(this);
    this.editAnswer = this.editAnswer.bind(this);
    this.cancelAnswerEdit = this.cancelAnswerEdit.bind(this);
    this.confirmAnswerEdit = this.confirmAnswerEdit.bind(this);
    this.checkValidity = this.checkValidity.bind(this);
    this.changeAnswerOrder = this.changeAnswerOrder.bind(this);
  }

  componentDidMount() {
    this.props.fetchDetails();
    this.setState({ rearrangeMode: false });
  }

  componentDidUpdate(prevProps) {
    if (this.props.location !== prevProps.location) {
      if (this.props.match.params.customSurveyId)
        this.setState({ rearrangeMode: false, addQuestionVisible: false });
    }
  }

  toggleAddtrue() {
    this.setState({
      addQuestionVisible: true,
      editId: '',
      question: '',
      answer: '',
      answers_attributes: [],
      suggestedQuestions: [],
      questionError: '',
      answerError: '',
    });
  }

  toggleAddfalse() {
    this.setState({
      addQuestionVisible: false,
      question: '',
      answer: '',
      answers_attributes: [],
      survey_template_question_id: null,
    });
  }

  handleKeyPress(e) {
    if (e.key === 'Enter') {
      this.addAnswer();
    }
  }

  handleChange(e) {
    const { value, name } = e.target;
    let _state = {};

    _state[name] = value;

    if (name === 'question') {
      _state.questionError = '';
      this.fetchSuggestedQuestions(value);
    } else {
      _state.answerError = '';
    }
    this.setState(_state);
  }

  handleBlur = () => {
    setTimeout(() => {
      this.setState({
        suggestedQuestions: [],
      });
    }, 100);
  };

  fetchSuggestedQuestions = value => {
    const { timer } = this.state;
    const { customSurveyId, id: businessId } = this.props.match.params;

    clearTimeout(timer);
    if (!value) {
      this.setState({ suggestedQuestions: [] });
      return;
    }

    const newTimer = setTimeout(() => {
      CustomSurveyQuestionApi.getSuggestions({
        query: value,
        custom_survey_id: customSurveyId,
        business_id: businessId,
      })
        .then(({ data }) => {
          this.setState({ suggestedQuestions: data });
        })
        .catch(console.log);
    }, 300);
    this.setState({ timer: newTimer });
  };

  addAnswer() {
    let answers_attributes = this.state.answers_attributes;
    let answers = answers_attributes.filter(answer => {
      return !answer.is_deleted;
    });

    if (answers.length < 5) {
      if (this.state.answer.trim() != '' || null) {
        answers_attributes.push({ answer: this.state.answer });
        this.setState({
          answer: '',
          answers_attributes,
          answerError: '',
        });
      } else {
        this.setState({ answerError: 'Answer cannot be blank' });
      }
    } else {
      this.setState({ answerError: 'Maximum 5 answers only' });
    }
  }

  deleteQuestion(questionId, e) {
    e.stopPropagation();
    this.setState({ modalToggle: true, questionId });
  }

  confirmDeleteQuestion() {
    CustomSurveyQuestionApi.delete(this.state.questionId)
      .then(({ data }) => {
        toast.success(() => (
          <div>
            <FontAwesomeIcon icon="check-circle" />
            Question deleted successfully
          </div>
        ));
        this.cancelQuestionDelete();
        this.props.fetchDetails();
      })
      .catch(
        e => (
          toast.error(() => (
            <div>
              <FontAwesomeIcon icon="exclamation-triangle" />
              Error while deleting question
            </div>
          )),
          console.log(e)
        )
      );
  }

  cancelQuestionDelete() {
    this.setState({ modalToggle: false });
  }

  editQuestion(editId) {
    this.setState({ editId, addQuestionVisible: false });
    CustomSurveyQuestionApi.getDetails(editId)
      .then(({ data }) => {
        this.setState({
          answers_attributes: data.answers,
          question: data.question,
          answer_order: data.answer_order,
        });
      })
      .catch(
        e => (
          toast.error(() => (
            <div>
              <FontAwesomeIcon icon="exclamation-triangle" />
              Error while fetching question
            </div>
          )),
          console.log(e)
        )
      );
  }

  confirmEdit(questionObj) {
    const { question, answer_attributes } = questionObj;

      CustomSurveyQuestionApi.update(
        this.state.editId,
        question,
        answer_attributes
      )
        .then(({ data }) => {
          toast.success(() => (
            <div>
              <FontAwesomeIcon icon="check-circle" />
              Question updated successfully
            </div>
          ));
          this.setState({ editId: null, suggestedQuestions: [] });
          this.props.fetchDetails();
        })
        .catch(
          e => (
            toast.error(() => (
              <div>
                <FontAwesomeIcon icon="exclamation-triangle" />
                Error while updating question
              </div>
            )),
            console.log(e)
          )
        );

  }

  cancelEdit() {
    this.setState({
      editId: '',
      questionError: '',
      answerError: '',
      suggestedQuestions: [],
    });
  }

  checkValidity() {
    const { question, answers_attributes } = this.state;
    const answers = answers_attributes.filter(answer => {
      return !answer.is_deleted;
    });
    if (question.trim() == '' || null) {
      this.setState({ questionError: 'Question field cannot be blank' });
      return false;
    }
    if (answers.length < 1) {
      this.setState({ questionError: 'Atleast one option is required' });
      return false;
    }
    return true;
  }

  addQuestion(newQuestion) {
    const { question, answer_attributes, survey_template_question_id, input_type_id } = newQuestion;
    CustomSurveyQuestionApi.addNew(
      question,
      answer_attributes,
      this.props.customSurveyId,
      survey_template_question_id,
      input_type_id
    )
      .then(data => {
        toast.success(() => (
          <div>
            <FontAwesomeIcon icon="check-circle" />
            Question added successfully
          </div>
        ));
        this.toggleAddfalse();
        this.props.fetchDetails();
      })
      .catch(
        e => (
          toast.error(() => (
            <div>
              <FontAwesomeIcon icon="exclamation-triangle" />
              Error while creating question
            </div>
          )),
          console.log(e)
        )
      );
  }

  editAnswer(editAnswerObject) {
    let answers_attributes = this.state.answers_attributes;
    let index = answers_attributes.indexOf(editAnswerObject);
    this.setState({
      editAnswerObject,
      editAnswerText: editAnswerObject.answer,
      editAnswerIndex: index,
    });
  }

  cancelAnswerEdit() {
    this.setState({
      editAnswerObject: {},
      editAnswerText: '',
      editAnswerIndex: '',
    });
  }

  confirmAnswerEdit() {
    if (this.state.editAnswerText.trim() != '' || null) {
      let answer = this.state.editAnswerText;
      let answers_attributes = this.state.answers_attributes;
      answers_attributes[this.state.editAnswerIndex].answer = answer;
      this.setState({
        answers_attributes,
        editAnswerObject: {},
        editAnswerText: '',
        editAnswerIndex: '',
      });
    } else {
      this.setState({ answerError: 'Answer cannot be empty' });
    }
  }

  handleQuestionArrange = () => {
    let { rearrangeMode } = this.state;
    if (rearrangeMode) {
      this.props.saveQuestionOrder();
    }
    this.setState({ rearrangeMode: !rearrangeMode });
  };

  setOrderedQuestions = questions => {
    this.props.setOrderedQuestions(questions);
  };

  changeAnswerOrder(answersAttributes) {
    this.setState({ answers_attributes: answersAttributes });
  }

  deleteAnswer(answer) {
    let answers_attributes = this.state.answers_attributes;
    let index = answers_attributes.indexOf(answer);
    answers_attributes[index].is_deleted = true;
    this.setState({ answers_attributes });
  }

  handleSuggestionSelected = selectedQuestion => {
    const { answers, question, survey_template_question_id } = selectedQuestion;
    const answers_attributes = answers.map(
      ({ answer, survey_template_question_answer_id }) => ({
        answer,
        survey_template_question_answer_id,
      })
    );
    this.setState({
      question,
      survey_template_question_id,
      answers_attributes,
      suggestedQuestions: [],
      toggleSuggestions: false,
    });
  };

  handleSuggestionsToggle = () => {
    this.setState(({ toggleSuggestions }) => ({
      toggleSuggestions: !toggleSuggestions,
    }));
  };

  toggleAddQuestion = () => {
    this.setState(({ addQuestionVisible }) => ({
      addQuestionVisible: !addQuestionVisible,
    }));
  };

  render() {
    const {
      suggestedQuestions,
      modalToggle,
      rearrangeMode,
      answerError,
      addQuestionVisible,
      question,
      answer,
      answers_attributes,
      editAnswerObject,
      editAnswerText,
      questionError,
      editId,
      toggleSuggestions,
    } = this.state;

    const { questions } = this.props;

    return (
      <div>
        <DeleteQuestionModal
          modalToggle={modalToggle}
          cancelQuestionDelete={this.cancelQuestionDelete}
          confirmDeleteQuestion={this.confirmDeleteQuestion}
        />
        <div className="clearfix">
          <ActionButtons
            toggleAdd={this.toggleAddtrue}
            rearrangeMode={rearrangeMode}
            handleQuestionArrange={this.handleQuestionArrange}
          />
        </div>
        <AddNewQuestion
          key={addQuestionVisible}
          addQuestionVisible={addQuestionVisible}
          toggleAddQuestion={this.toggleAddQuestion}
          addQuestion={this.addQuestion}
        />
        {rearrangeMode ? (
          <RearrangeQuestions
            questions={questions}
            setOrderedQuestions={this.setOrderedQuestions}
          />
        ) : (
          <QuestionsLists
            changeAnswerOrder={this.changeAnswerOrder}
            editId={editId}
            question={question}
            answers_attributes={answers_attributes}
            answer={answer}
            editAnswerObject={editAnswerObject}
            editAnswerText={editAnswerText}
            editQuestion={this.editQuestion}
            editAnswer={this.editAnswer}
            cancelAnswerEdit={this.cancelAnswerEdit}
            confirmAnswerEdit={this.confirmAnswerEdit}
            addAnswer={this.addAnswer}
            cancelEdit={this.cancelEdit}
            deleteQuestion={this.deleteQuestion}
            deleteAnswer={this.deleteAnswer}
            questions={questions}
            handleChange={this.handleChange}
            confirmEdit={this.confirmEdit}
            handleKeyPress={this.handleKeyPress}
            questionError={questionError}
            answerError={answerError}
          />
        )}
      </div>
    );
  }
}

export default withRouter(CustomSurveyQuestions);



// WEBPACK FOOTER //
// ./src/components/customSurvey/questions/customSurveyQuestions.js